"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchLoadCreator = void 0;
var searchLoadCreator = function (event) {
    var eventData = {
        action: event.eventData.searchLoad.searchPagination === 0 ? "search-no-results" : "search-success",
        event: 'search-load',
        eventInfo: 'search-load',
        search: __assign(__assign({}, event.eventData.searchLoad), { searchResults: event.eventData.searchLoad.searchResults.toString(), searchPagination: event.eventData.searchLoad.searchPagination.toString() })
    };
    return eventData;
};
exports.searchLoadCreator = searchLoadCreator;
